<app-policies-style [documentData]="documentData">